import { FormItemLayout } from '@framework/form';

const inputLayout: FormItemLayout = {
  removeLabelSpace: true,
  hideVisualLabel: true,
};
export const AdvancedSearchFormItemLayout: FormItemLayout = inputLayout;
